import styled from "styled-components";

const Ul = styled.ul`
  padding-left: 0;
  margin-top: 0.5rem;
  list-style-type: none;
`;

const DeploymentLinks = (): JSX.Element => (
  <small>
    <Ul>
      <li>
        <a href="/coverage">Coverage</a>
      </li>
      <li>
        <a href="/coverage/junit.html">junit</a>
      </li>
      <li>
        <a href="/coverage/bundle-tree.html">bundle tree</a>
      </li>
      <li>
        <a href="/coverage/jest_html_reporters.html">Jest html report</a>
      </li>
    </Ul>
  </small>
);

export default DeploymentLinks;
